import { render, staticRenderFns } from "./NewTopBannerModal.vue?vue&type=template&id=27eba6f8&"
import script from "./NewTopBannerModal.vue?vue&type=script&lang=js&"
export * from "./NewTopBannerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports